import { render, staticRenderFns } from "./ChatMessageItem.vue?vue&type=template&id=4b07bdda&scoped=true"
import script from "./ChatMessageItem.vue?vue&type=script&lang=js"
export * from "./ChatMessageItem.vue?vue&type=script&lang=js"
import style0 from "./ChatMessageItem.vue?vue&type=style&index=0&id=4b07bdda&prod&lang=scss&scoped=true"
import style1 from "./ChatMessageItem.vue?vue&type=style&index=1&id=4b07bdda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b07bdda",
  null
  
)

export default component.exports